import navbar from './navbar';

/** 间距属性 */
export type SpacingProperty = 'padding' | 'margin' | 'border-radius';

export default {
  /**
   * 获取Sticky样式
   */
  getSticky: (top?: number, zIndex?: number): AnyObject => {
    const navbarInfo = navbar.get();
    return {
      page: {
        overflowX: 'inherit',
        overflowY: 'inherit',
      },
      view: {
        position: 'sticky',
        top: `${top || navbarInfo.totalHeight}px`,
        zIndex: zIndex || 991,
      },
    };
  },

  /**
   * 格式化 CSS 间距值（padding/margin）
   * @param values - 间距值数组 [上, 右, 下, 左]
   * @param property - CSS 属性名 ('padding' | 'margin')
   * @param unit - CSS 单位，默认 'rpx'
   * @returns CSS 样式对象
   * @example
   * formatSpacing([10], 'margin') => { margin: '10rpx' }
   * formatSpacing([10, 20], 'padding') => { padding: '10rpx 20rpx' }
   */
  formatSpacing(values?: number[], property: SpacingProperty = 'padding', unit = 'rpx') {
    if (!values?.length) return {};

    const spacingValues = values.map((v) => `${v}${unit}`);
    const [top, right, bottom, left] = spacingValues;

    let value = '';
    switch (spacingValues.length) {
      case 1:
        value = top;
        break;
      case 2:
        value = `${top} ${right}`;
        break;
      case 3:
        value = `${top} ${right} ${bottom}`;
        break;
      case 4:
        if (top === right && right === bottom && bottom === left) {
          // 所有值相等
          value = top;
        } else if (top === bottom && right === left) {
          // 上下相等且左右相等
          value = `${top} ${right}`;
        } else {
          // 完整写法
          value = `${top} ${right} ${bottom} ${left}`;
        }
        break;
    }

    return value ? { [property]: value } : {};
  },
};
